
import { defineComponent } from 'vue'
import CookiesCoreMixinVue from '@/modules/CookiesCoreMixin.vue'

export default defineComponent({
  mixins: [CookiesCoreMixinVue],
  created () {
  },
  mounted () {},
  data () {
    return {}
  },
  computed: {
    Name () {
      return this.Translate('Catalogs')
    },
    Tabs () {
      return [
        { Name: this.Translate('My Catalogs'), Link: 'Edit', Access: this.Access('Catalogue_Read') }
        // { Name: this.Translate('Catalogs'), Link: 'Catalogs', Access: this.Access('Catalogue_Read') }
      ] as Array<CookiesTabs>
    }
  },
  methods: {},
  watch: {}
})
